import { LEFT_MENU_WIDTH } from 'theme/constants';

export const contentWrapperStyle = {
  height: 'calc(100vh - 107px)',

  ['@media (min-width: 1610px)']: {
    width: 'calc(0.85 * 1440px)',
  },

  ['@media (max-width: 1610px)']: {
    width: `calc(0.85 * (100vw - ${LEFT_MENU_WIDTH}px - 2 * 24px))`,
  },
};
